import styled, { keyframes } from 'styled-components';
import scaleSize from '../../utils/scale-size';

const loaderAnimation = keyframes`
  0% {
    transform: scale(1);
    background-color: ${({ theme }) => theme.activeColor};
    border-radius: ${scaleSize(16)}px;
  }

  50% {
    transform: scale(0.7);
    background-color: ${({ theme }) => theme.imagePlaceholder};
    border-radius: ${scaleSize(16 * 0.7)}px;
  }
`;

export const LoaderWrapper = styled.div`
  width: ${scaleSize(1920)}px;
  height: ${scaleSize(1080)}px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ theme, cleanBackground }) =>
    cleanBackground ? 'none' : theme.backgroundLoaderColor};
  z-index: 101;
`;

export const Loader = styled.div`
  width: ${scaleSize(140)}px;
  height: ${scaleSize(140)}px;
  transform: translate(-50%, -50%);
  transition: none;
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 101;
  
  & > div {
    width: ${scaleSize(60)}px;
    height: ${scaleSize(60)}px;
    background-color: ${({ theme }) => theme.activeColor};
    position: absolute;
    transform-origin: 50% 50%;
    border-radius: ${scaleSize(16)}px;
    animation-name: ${loaderAnimation};
    animation-duration: 0.8s;
    animation-iteration-count: infinite;
    animation-fill-mode: both;

    &:first-child {
      top: 0;
      left: 0;
      animation-delay: 0s;
    }

    &:nth-child(2) {
      top: 0;
      right: 0;
      animation-delay: 0.2s;
    }

    &:nth-child(3) {
      bottom: 0;
      right: 0;
      animation-delay: 0.4s;
    }

    &:last-child {
      bottom: 0;
      left: 0;
      animation-delay: 0.6s;
    }
  }
  }
`;
